export default "__VITE_ASSET__DxGLh2SS__"